import { authFetch } from "~/services/fetch";

export async function getOccurrencesAssociatedPeopleByInvolvementType({
  startDate,
  finishDate,
  involvementTypeId,
  arrested,
  peopleCircunstanceId,
  destinationId
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-people-by-involvement-type',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        involvement_type_id: involvementTypeId,
        arrested: arrested,
        people_circunstance_id: peopleCircunstanceId,
        destination_id: destinationId,
      }
    })
    return data;
  } catch (error) {
    throw error
  }
}

export async function getOccurrencesAssociatedPeopleArrested({
  startDate,
  finishDate,
  involvementTypeId,
  arrested,
  peopleCircunstanceId,
  destinationId
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-people-arrested',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        involvement_type_id: involvementTypeId,
        arrested: arrested,
        people_circunstance_id: peopleCircunstanceId,
        destination_id: destinationId,
      }
    })
    return data;
  } catch (error) {
    throw error
  }
}

export async function getOccurrencesAssociatedPeopleByCircunstance({
  startDate,
  finishDate,
  involvementTypeId,
  arrested,
  peopleCircunstanceId,
  destinationId
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-people-by-circunstance',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        involvement_type_id: involvementTypeId,
        arrested: arrested,
        people_circunstance_id: peopleCircunstanceId,
        destination_id: destinationId,
      }
    })
    return data;
  } catch (error) {
    throw error
  }
}

export async function getOccurrencesAssociatedPeopleByDestination({
  startDate,
  finishDate,
  involvementTypeId,
  arrested,
  peopleCircunstanceId,
  destinationId
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-people-by-destination',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        involvement_type_id: involvementTypeId,
        arrested: arrested,
        people_circunstance_id: peopleCircunstanceId,
        destination_id: destinationId,
      }
    })
    return data;
  } catch (error) {
    throw error
  }
}

export async function getOccurrencesAssociatedPeopleByPublicAgent({
  startDate,
  finishDate,
  involvementTypeId,
  arrested,
  peopleCircunstanceId,
  destinationId
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-people-by-public-agent',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        involvement_type_id: involvementTypeId,
        arrested: arrested,
        people_circunstance_id: peopleCircunstanceId,
        destination_id: destinationId,
      }
    })
    return data;
  } catch (error) {
    throw error
  }
}

export async function getOccurrencesAssociatedPeopleByOrganization({
  startDate,
  finishDate,
  involvementTypeId,
  arrested,
  peopleCircunstanceId,
  destinationId
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-people-by-organization',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        involvement_type_id: involvementTypeId,
        arrested: arrested,
        people_circunstance_id: peopleCircunstanceId,
        destination_id: destinationId,
      }
    })
    return data;
  } catch (error) {
    throw error
  }
}

export async function getOccurrencesAssociatedPeopleByGender({
  startDate,
  finishDate,
  involvementTypeId,
  arrested,
  peopleCircunstanceId,
  destinationId
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-people-by-gender',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        involvement_type_id: involvementTypeId,
        arrested: arrested,
        people_circunstance_id: peopleCircunstanceId,
        destination_id: destinationId,
      }
    })
    return data;
  } catch (error) {
    throw error
  }
}

export async function getOccurrencesAssociatedPeopleByOccupation({
  startDate,
  finishDate,
  involvementTypeId,
  arrested,
  peopleCircunstanceId,
  destinationId
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-people-by-occupation',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        involvement_type_id: involvementTypeId,
        arrested: arrested,
        people_circunstance_id: peopleCircunstanceId,
        destination_id: destinationId,
      }
    })
    return data;
  } catch (error) {
    throw error
  }
}

export async function getOccurrencesAssociatedPeopleByAge({
  startDate,
  finishDate,
  involvementTypeId,
  arrested,
  peopleCircunstanceId,
  destinationId
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-people-by-age',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        involvement_type_id: involvementTypeId,
        arrested: arrested,
        people_circunstance_id: peopleCircunstanceId,
        destination_id: destinationId,
      }
    })
    return data;
  } catch (error) {
    throw error
  }
  
}
export async function getOccurrencesAssociatedPeopleByOccurrenceType({
  startDate,
  finishDate,
  involvementTypeId,
  arrested,
  peopleCircunstanceId,
  destinationId
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-people-by-occurrence-type',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        involvement_type_id: involvementTypeId,
        arrested: arrested,
        people_circunstance_id: peopleCircunstanceId,
        destination_id: destinationId,
      }
    })
    return data;
  } catch (error) {
    throw error
  }
  
}
